export default __webpack_public_path__ + "static/media/DS.4bcf98ed.jpeg";